import { useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import { Button, Loader, Text, toasts } from '../../../../ui-component';
import { RightArrowIcon } from '../../../../assets/icons';
import { ScreenContainer, LoginContainer } from '../../style';

import { api } from '../../../../utils/apiRequest';

type LoginScreenProps = {
  phoneNumber: string;
  dialCode: string;
  setPhoneNumber: (num: string) => void;
  setDialCode: (code: string) => void;
  setScreenType: (type: 'enterMoblie' | 'enterOTP') => void;
};

const LoginScreen = (props: LoginScreenProps) => {
  const { phoneNumber, setPhoneNumber, setDialCode, setScreenType } = props;

  const [errMsg, setErrMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [fullPhoneNumber, setFullPhoneNumber] = useState<string>('');
  const defaultCountry = 'IN';

  const handlePhoneChange = (value: string | undefined) => {
    if (value) {
      try {
        const parsed = parsePhoneNumber(value);

        if (parsed) {
          setDialCode(`+${parsed.countryCallingCode}`);
          setPhoneNumber(parsed.nationalNumber);
          setFullPhoneNumber(value);
          setErrMsg('');
        }
      } catch (error) {
        setErrMsg('Invalid phone number');
      }
    } else {
      setPhoneNumber('');
      setDialCode('+91');
      setFullPhoneNumber('');
    }
  };

  const handleRequestOtp = async () => {
    try {
      setIsLoading(true);

      if (_isEmpty(errMsg) && !_isEmpty(phoneNumber) && !_isEmpty(fullPhoneNumber)) {
        // 🔁 CALL YOUR GENERATE OTP API
        // Adjust the path if your apiRequest adds /api/v1/ automatically
        const response = await api.postRequest('api/v1/auth/user/generate_otp', {
          mobile_number: fullPhoneNumber, // e.g. "+919090909090"
        });

        const { data, status } = response || {};

        if (status && data?.msg === 'otp sent') {
          setScreenType('enterOTP');
        } else {
          toasts('error', data?.msg || 'Failed to send OTP', 'request-otp');
        }
      }
    } catch (error: any) {
      toasts('error', error?.message || 'Failed to send OTP', 'request-otp');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ScreenContainer>
      <LoginContainer>
        <Text size="xxxl" color="var(--color-black)" fontWeight={800}>
          Login Account
        </Text>
        <Text color="var(--color-black)" className="login-help-text">
          Please enter your mobile number to receive a One Time Password via SMS
        </Text>

        <PhoneInput
          defaultCountry={defaultCountry}
          value={fullPhoneNumber}
          onChange={handlePhoneChange}
          international
          countryCallingCodeEditable={false}
          className="w-full h-12 rounded-md border-1 border-gray-300"
          style={{
            width: '100%',
            height: '48px',
            fontSize: '1.5rem',
            border: '1px solid black',
            background: '#3b36360a',
            padding: '10px',
            borderRadius: '6px',
          }}
        />

        {!_isEmpty(errMsg) && <Text color="tertiary">{errMsg}</Text>}

        <Button
          className="otp-btn"
          disabled={!_isEmpty(errMsg) || _isEmpty(phoneNumber)}
          trailingIcon={<RightArrowIcon />}
          onClick={handleRequestOtp}
        >
          Request OTP
        </Button>
      </LoginContainer>
      <Loader showLoader={isLoading} />
    </ScreenContainer>
  );
};

export default LoginScreen;
